import { PropsWithChildren } from "react";
import "./circle.less";

interface Props {
  className?: string
}

export default function Circle(props: PropsWithChildren<Props>) {
  let className = "circle";
  if (props.className) {
    className += " " + props.className;
  }

  return <div className={className}>
    {props.children}
  </div>
}